var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.platforms.length
    ? _c("div", { staticClass: "section-gameProvider" }, [
        _c("div", { staticClass: "section-gameProvider__header" }, [
          _c("h2", [_vm._v(_vm._s(_vm.$t("front.game.titles.providers")))]),
          _c(
            "div",
            { staticClass: "slider-nav" },
            [
              _c("router-link", { attrs: { to: _vm.seeAllPath } }, [
                _vm._v(
                  "\n                " +
                    _vm._s(_vm.$t("front.game.button.see_all")) +
                    "\n                "
                ),
                _c(
                  "svg",
                  {
                    attrs: {
                      width: "7",
                      height: "12",
                      viewBox: "0 0 7 12",
                      fill: "none",
                      xmlns: "http://www.w3.org/2000/svg"
                    }
                  },
                  [
                    _c("path", {
                      attrs: { d: "M1 11L6 6L1 1", stroke: "#926D20" }
                    })
                  ]
                )
              ]),
              _c(
                "v-btn",
                {
                  staticClass: "prev",
                  attrs: { id: "#button-prev-relacionadosXX" },
                  on: { click: _vm.showPrev }
                },
                [
                  _c(
                    "svg",
                    {
                      attrs: {
                        width: "11",
                        height: "10",
                        viewBox: "0 0 11 10",
                        fill: "none",
                        xmlns: "http://www.w3.org/2000/svg"
                      }
                    },
                    [
                      _c("path", {
                        attrs: {
                          d: "M6 1L2 5L6 9",
                          stroke: "white",
                          "stroke-width": "1.5"
                        }
                      }),
                      _c("path", {
                        attrs: {
                          d: "M2.5 5H10.5",
                          stroke: "white",
                          "stroke-width": "1.5"
                        }
                      })
                    ]
                  )
                ]
              ),
              _c(
                "v-btn",
                {
                  staticClass: "next",
                  attrs: { id: "#button-next-relacionadosXX" },
                  on: { click: _vm.showNext }
                },
                [
                  _c(
                    "svg",
                    {
                      attrs: {
                        width: "11",
                        height: "10",
                        viewBox: "0 0 11 10",
                        fill: "none",
                        xmlns: "http://www.w3.org/2000/svg"
                      }
                    },
                    [
                      _c("path", {
                        attrs: {
                          d: "M5 1L9 5L5 9",
                          stroke: "white",
                          "stroke-width": "1.5"
                        }
                      }),
                      _c("path", {
                        attrs: {
                          d: "M8.5 5H0.5",
                          stroke: "white",
                          "stroke-width": "1.5"
                        }
                      })
                    ]
                  )
                ]
              )
            ],
            1
          )
        ]),
        _c(
          "div",
          { staticClass: "section-gameProvider__content" },
          [
            _vm.platforms.length
              ? _c(
                  "swiper",
                  {
                    ref: "carousel",
                    staticClass: "section-gameProvider__slider",
                    attrs: { options: _vm.settings }
                  },
                  _vm._l(_vm.platforms, function(item, index) {
                    return _c(
                      "swiper-slide",
                      { key: index, staticClass: "item" },
                      [
                        _c("router-link", { attrs: { to: item.pageUrl } }, [
                          _c(
                            "picture",
                            [
                              _vm._l(item.logo.sourcesTypes, function(
                                sourceType,
                                index
                              ) {
                                return _c("source", {
                                  key: index,
                                  attrs: {
                                    "data-srcset": item.logo[sourceType],
                                    type: "image/" + sourceType
                                  }
                                })
                              }),
                              _c("img", {
                                attrs: {
                                  "data-src": item.logo.jpg,
                                  alt: item.title
                                }
                              })
                            ],
                            2
                          )
                        ])
                      ],
                      1
                    )
                  }),
                  1
                )
              : _vm._e()
          ],
          1
        )
      ])
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }